/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import { connect } from 'react-redux';
// import Toast from './sub_components/toast';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { staticContentsImagePath as BASE_IMAGE_PATH, OPERATOR_ID } from '../configs/const';
import Maintanence from './sub_components/maintanence'
import * as constants from '../configs/const'
import Loginb2cHeader from './loginb2cHeader';
import Loginb2cFooter from './loginb2cFooter';
import { DMNNM } from '../configs/ops';
// import bannerList from 'https://images.staticcontents.com/banners/list.json'

let oid = OPERATOR_ID.toLowerCase()
// const recaptchaRef = React.createRef();
const hostname = window && window.location && window.location.hostname;

class ExchangeVirtualSportsSEO extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // uid: "",
            // passcode: "",
            // passVisible: false,
            // rememberMe: false,
            date: "",
            // showToast: false,
            toastMsg: "",
            toastType: "",
            showDownLoad: false,
            inMaitanence: false,
            hasUmShow: true,
            recapchaVal: "",
            isDev: false,
            desktopBanners: {},
            mobileBanners: {},
            operatorDesktopBanners: {},
            operatorMobileBanners: {},
            showPopup: false,
            showLoginPopup: false,
            selectedSection: "",
            clientWidth: document.documentElement.clientWidth,
        };
    }

    formatPickerDate(date) {
        var d = date,
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;
        year = year.toString().slice(-2)
        return [year, month, day].join('');
    }



    // onPasswodVisible() {
    //     if (!!this.state.passVisible) {
    //         document.getElementById("passcode").type = "Password"
    //         document.getElementById("passcode-m").type = "Password"
    //     } else {
    //         document.getElementById("passcode").type = "text"
    //         document.getElementById("passcode-m").type = "text"
    //     }
    //     this.setState({ passVisible: !this.state.passVisible })
    // }

    hidePopup(view = "") {
        this.setState({ hasUmShow: false, [`show${view}Popup`]: false })

    }
    showPopup(view = "") {
        // debugger
        this.setState({ [`show${view}Popup`]: true })
    }
    // hideLoginPopup() {
    //     this.setState({ hasUmShow: false, showloginPopup:false })

    // }
    // showLoginPopup() {
    //     this.setState({ showloginPopup: true })
    // }
    togglePopupBetweenLoginSignup(view = "") {
        this.hidePopup(view === "" ? "Login" : "");
        this.showPopup(view);
    }
    toggleSelectedSection(name) {
        this.setState({ selectedSection: this.state.selectedSection === name ? "" : name });
    }
    render() {
        let settings = {
            dots: true,
            infinite: true,
            speed: 300,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 5000
        };
        return (
            <div className="radheexch radheexchlogin bg-white-login ">


                <Loginb2cHeader history={this.props.history}></Loginb2cHeader>
                {/* <div className='login-mar-top100'>
            <section className='sportbook-screen'>
                <a onClick={(e) => { this.showPopup("Login") }}><img alt="" src={BASE_IMAGE_PATH + "/casino/banner/loginimages/sportbook-screen.jpg"} className="sp-desktop-show" /></a>
                <a onClick={(e) => { this.showPopup("Login") }}><img alt="" src={BASE_IMAGE_PATH + "/casino/banner/loginimages/sportbook-screen-mobile.jpg"} className="sp-mobile-show" /></a>
            </section>
        </div> */}
                <div className='login-mar-top100 '>
                    <section className='sportbook-livecasino'>
                        <div>
                            <img alt="Exchange Banner" src={BASE_IMAGE_PATH + "/casino/banner/loginimages/exchanges-banner.jpg"} />

                        </div>
                        <div>
                            <div className="">
                                <div className='seo-content-page'>
                                    <h2 align="center">{DMNNM} – The Best Platform for Virtual Sports Betting in India</h2>
                                    <p>
                                        With mobile phones becoming a common sight and internet connection a
                                        necessity, online and virtual gaming has become one of the world's biggest
                                        and fastest growing industries. This has also resulted in a rise in    <strong>Virtual Sports betting </strong>everywhere. While till recently, it
                                        was a mere western phenomenon, the scene of    <strong>Virtual Sports betting in India </strong>too is gaining a lot of
                                        attention among the youngsters. As a result, more people in India have one
                                        or other <strong>Virtual Sports betting ID </strong>than at any time in the
                                        past.
                                    </p>
                                    <p>
                                        The favourite virtual sport in India is cricket. With the cricketers like
                                        Dhoni and Kohli taking on and destroying the balling attacks of the world,
                                        Indians have maintained a never-ending admiration of cricket that they like
                                        to give expressions to through virtual games.
                                    </p>
                                    <p>
                                        Whether cricket or any other game, starting on    <strong>Virtual Sports betting </strong>is easy. All you need is to be an
                                        adult, be of sound mind, have a bank account with some balance, and an    <strong>online game ID</strong>. Once you have got all that, you are good
                                        to start <strong>Virtual Sports betting in India</strong>.
                                    </p>
                                    <p>
                                        <strong>Betting In The Premier League </strong>
                                    </p>
                                    <p>
                                        <strong>Premier League </strong>
                                        is one of the most important occasions for <strong>virtual game betting</strong>. No one with an    <strong>online game ID </strong>can help it; the best is just too tempting
                                        not to give a try. If you, too, are interested in betting in <strong>Premier League, </strong>you should consider getting our    <strong> Virtual Sports betting ID</strong> and start betting.
                                    </p>
                                    <p>
                                        There are several perks of online betting in the Premier League in India -
                                        it is much more secure and regulated, the odds given are much more
                                        lucrative, it is a lot more convenient as you can do it anytime and
                                        anywhere, and so on. For a dedicated cricket fan, betting is not merely
                                        about speculating who will win but something that runs much deeper - it is
                                        a way of showing love to their favorite players or side, it is a way of
                                        making the victory of their team much more special.
                                    </p>
                                    <p>
                                        <strong>Best Place For Online Sports Betting.</strong>
                                    </p>
                                    <p>
                                        Though there are several platforms for <strong>Premier League betting </strong>as well as other <strong>Virtual Sports betting</strong>, {DMNNM} is simply the best <strong>online game ID</strong>. Our platform is famous for betting in    <strong>Premier League betting, </strong>especially in the case of cricket.
                                    </p>
                                    <p>
                                        In particular, this is because we are the only platform for    <strong>virtual game betting </strong>of good standing that offers our
                                        customers a chance to bet in Indian rupees. Our customers thus find us
                                        perfect for <strong>Virtual Sports betting in India</strong>.
                                    </p>
                                    <p>
                                        Apart from<strong> Premier League betting</strong>, we also offer betting
                                        options in other games as well as sports. With our <strong>Virtual Sports betting ID, </strong>you can bet on    <strong>Premier League,</strong> international matches, world cup matches,
                                        etc. While cricket is an obvious favorite, it is not the only game we cater
                                        to. You will find that we offer the best customer experience, whatever    <strong>virtual game betting </strong>you may be into.
                                    </p>
                                    <p>
                                        Some people have watched, studied, and analysed the cricket games so
                                        thoroughly that they have developed a sort of intuition as to how games
                                        should go and are often proven right by the results. If you are one such
                                        player, then {DMNNM} can be the perfect platform to encash that intuition.
                                        However, it is important that one should act with self-discipline and not
                                        get addicted to betting.
                                    </p>
                                    <p>
                                        1xBook makes it super-easy to make and manage your bets. We are the most
                                        lucrative, safest, and most immersive platform for online betting.
                                    </p>

                                </div>
                            </div>

                        </div>
                    </section>
                </div>


                <Loginb2cFooter history={this.props.history}></Loginb2cFooter>


            </div>)

    }
}

function mapStateToProps(state) {
    return {
    };
}

function mapDispatchToProps(dispatch) {
    return {
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(ExchangeVirtualSportsSEO);